module.exports = __webpack_public_path__ + "static/media/glip_logo.a4be068f.svg";